'use client';

import styles from './Footer.module.scss';
import { useNewsletterForm } from './useNewsletterForm';

export default function NewsletterForm() {
  const { email, emailError, message, loading, handleChange, handleBlur, handleSubmit } = useNewsletterForm();

  return (
    <div>
      <div className={styles.emailRow}>
        <input
          type="email"
          placeholder="Email ID"
          className={styles.emailInput}
          value={email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <button
          type="button"
          className={styles.subscribeBtn}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Please wait…' : 'Subscribe'}
        </button>
      </div>
      {emailError && <p className={styles.formError}>{emailError}</p>}
      {message    && <p className={styles.formSuccess}>{message}</p>}
    </div>
  );
}
